import first from "lodash/first";
import { graphql } from "react-relay";
import { readInlineData } from "relay-runtime";

import { article as articleData, section as sectionData } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import type { helpersGetFlexiUnitArticleLabelArticle$key } from "scmp-app/queries/__generated__/helpersGetFlexiUnitArticleLabelArticle.graphql";
import type { helpersGetFlexiUnitPodcastLabelPodcast$key } from "scmp-app/queries/__generated__/helpersGetFlexiUnitPodcastLabelPodcast.graphql";
import type { helpersGetFlexiUnitVideoLabelVideo$key } from "scmp-app/queries/__generated__/helpersGetFlexiUnitVideoLabelVideo.graphql";

export const getFlexiUnitVideoLabel = (reference?: helpersGetFlexiUnitVideoLabelVideo$key) => {
  const video = readInlineData(
    graphql`
      fragment helpersGetFlexiUnitVideoLabelVideo on Video @inline {
        sectionsV2 {
          value {
            ... on VideoSection {
              entityId
            }
          }
        }
      }
    `,
    reference ?? null,
  );

  if (!notEmpty(video)) return;

  const sectionIds = (first(video?.sectionsV2)?.value ?? []).map(section => section?.entityId);
  return sectionIds.includes(sectionData?.scmpOriginals?.entityId) ? "SCMP Originals" : "Video";
};

// Content Type: podcasts are "Podcast".
export const getFlexiUnitPodcastLabel = (
  reference?: helpersGetFlexiUnitPodcastLabelPodcast$key,
) => {
  const podcast = readInlineData(
    graphql`
      fragment helpersGetFlexiUnitPodcastLabelPodcast on Podcast @inline {
        __typename
      }
    `,
    reference ?? null,
  );

  return podcast?.__typename === "Podcast" ? "Podcast" : undefined;
};

// Article type: Opinion/Debate/Review/Column/Blogs are "SCMP Editorial", Series is
// "SCMP Series", Infographics is "Infographics".
export const getFlexiUnitArticleLabel = (
  reference?: helpersGetFlexiUnitArticleLabelArticle$key,
) => {
  const article = readInlineData(
    graphql`
      fragment helpersGetFlexiUnitArticleLabelArticle on Article @inline {
        types {
          value {
            entityId
          }
        }
      }
    `,
    reference ?? null,
  );

  if (!notEmpty(article)) return;

  const articleType = first(first(article?.types)?.value)?.entityId ?? "";
  switch (articleType) {
    case articleData.types.blogs.entityId:
    case articleData.types.column.entityId:
    case articleData.types.debate.entityId:
    case articleData.types.opinion.entityId:
    case articleData.types.review.entityId:
      return "SCMP Editorial";
    case articleData.types.infographic.entityId:
      return "Infographics";
    case articleData.types.series.entityId:
      return "SCMP Series";
    default:
      return;
  }
};
